import React, { useEffect, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import './../../../Admin/QRFiles/musicscanner.css';
import bgImage from '../MusicScanner/qr.png' ; 

function CodeScanner() {
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!scannerRef.current) {
      const scanner = new Html5QrcodeScanner('reader', {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        rememberLastUsedCamera: true,
      });

      scanner.render(
        (decodedText) => {
          if (decodedText.startsWith('http')) {
            window.location.href = decodedText;
          } else {
            alert(`Scanned text: ${decodedText}`);
          }
        },
        (error) => {
          console.warn('QR Scan Error:', error);
        }
      );

      scannerRef.current = scanner;
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear().catch((err) => console.error('Clear error', err));
        scannerRef.current = null;
      }
    };
  }, []);

  return (
    <div className="scanner-wrapper">
      <div className="scanner-background" style={{ backgroundImage: `url(${bgImage})` }}></div>

      <div className="scanner-container">
        <div className="scanner-box">
          <h2 className="scanner-heading">📷 QR Code Scanner</h2>
          <p className="scanner-info">Align your QR code inside the square. It will scan automatically.</p>
          <div id="reader" className="scanner-reader"></div>
        </div>
      </div>
    </div>
  );
}

export default CodeScanner;
